function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import { Flex, Notice, Text } from '@applyboard/crystal-ui';
import { useApplicationNotices } from "../../../data/applicationNotices";
import { assert } from "../../../../../utils/assert";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function ApplicationNoticeList(_ref) {
  var regarding = _ref.regarding;
  var _useApplicationNotice = useApplicationNotices({
      regarding: regarding
    }),
    negativeNotices = _useApplicationNotice.negativeNotices,
    warningNotices = _useApplicationNotice.warningNotices,
    positiveNotices = _useApplicationNotice.positiveNotices;
  var displayedWarningNotices = warningNotices.filter(function (notice) {
    return notice.id !== 'duplicate-application-warning';
  });
  if ([].concat(_toConsumableArray(negativeNotices), _toConsumableArray(displayedWarningNotices), _toConsumableArray(positiveNotices)).length === 0) {
    return null;
  }
  var negativeNoticesWithLinks = negativeNotices.filter(function (notice) {
    return notice.link;
  });
  var warningNoticesWithLinks = displayedWarningNotices.filter(function (notice) {
    return notice.link;
  });
  var positiveNoticesWithLinks = positiveNotices.filter(function (notice) {
    return notice.link;
  });
  var negativeNoticesWithoutLinks = negativeNotices.filter(function (notice) {
    return !notice.link;
  });
  var warningNoticesWithoutLinks = displayedWarningNotices.filter(function (notice) {
    return !notice.link;
  });
  var positiveNoticesWithoutLinks = positiveNotices.filter(function (notice) {
    return !notice.link;
  });
  return _jsxs(Flex, {
    gap: 4,
    direction: "column",
    children: [negativeNoticesWithLinks.map(function (notice) {
      assert(notice.link);
      return _jsx(Notice, {
        intent: "negative",
        children: _jsxs(Flex, {
          gap: 4,
          direction: "column",
          children: [notice.message, _jsx(Notice.ButtonLink, {
            href: notice.link.href,
            children: notice.link.label
          })]
        }, notice.id)
      }, notice.id);
    }), negativeNoticesWithoutLinks.length > 0 && _jsx(Notice, {
      intent: "negative",
      children: _jsx(Flex, {
        gap: 4,
        direction: "column",
        children: negativeNoticesWithoutLinks.map(function (notice) {
          return _jsx(Text, {
            children: notice.message
          }, notice.id);
        })
      })
    }), warningNoticesWithLinks.map(function (notice) {
      assert(notice.link);
      return _jsx(Notice, {
        intent: "warning",
        children: _jsxs(Flex, {
          gap: 4,
          direction: "column",
          children: [notice.message, _jsx(Notice.ButtonLink, {
            href: notice.link.href,
            children: notice.link.label
          })]
        }, notice.id)
      }, notice.id);
    }), warningNoticesWithoutLinks.length > 0 && _jsx(Notice, {
      intent: "warning",
      children: _jsx(Flex, {
        gap: 4,
        direction: "column",
        children: warningNoticesWithoutLinks.map(function (notice) {
          return _jsx(Text, {
            children: notice.message
          }, notice.id);
        })
      })
    }), positiveNoticesWithLinks.map(function (notice) {
      assert(notice.link);
      return _jsx(Notice, {
        intent: "positive",
        children: _jsxs(Flex, {
          gap: 4,
          direction: "column",
          children: [notice.message, _jsx(Notice.ButtonLink, {
            href: notice.link.href,
            children: notice.link.label
          })]
        }, notice.id)
      }, notice.id);
    }), positiveNoticesWithoutLinks.length > 0 && _jsx(Notice, {
      intent: "positive",
      children: _jsx(Flex, {
        gap: 4,
        direction: "column",
        children: positiveNoticesWithoutLinks.map(function (notice) {
          return _jsx(Text, {
            children: notice.message
          }, notice.id);
        })
      })
    })]
  });
}